import { useState, type CSSProperties } from "react";
import type { AuthUser } from "@/state/authStore";

function avatarLetter(user: AuthUser): string {
  const source = user.first_name || user.telegram_username || "Telegram";
  return source.replace(/^@/, "").trim().slice(0, 1).toUpperCase() || "T";
}

function avatarColor(user: AuthUser): string {
  const palette = [
    "#e56555",
    "#f28c38",
    "#9b6ee5",
    "#4f9de8",
    "#33b679",
    "#d65a8a",
    "#6874e8",
  ];
  const seed = String(user.telegram_id || user.id || user.telegram_username);
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = ((hash << 5) - hash + seed.charCodeAt(i)) | 0;
  }
  return palette[Math.abs(hash) % palette.length];
}

export function AccountAvatar({ user }: { user: AuthUser }) {
  const photoUrl = user.photo_url?.trim() || null;
  const [failed, setFailed] = useState(false);
  const showPhoto = Boolean(photoUrl) && !failed;

  return (
    <span
      className="account-avatar"
      style={{ "--avatar-bg": avatarColor(user) } as CSSProperties}
    >
      {showPhoto ? (
        <img
          src={photoUrl ?? ""}
          alt=""
          referrerPolicy="no-referrer"
          onError={() => setFailed(true)}
        />
      ) : (
        avatarLetter(user)
      )}
    </span>
  );
}
